import { render, staticRenderFns } from "./CreateWord.vue?vue&type=template&id=5a1cf8bd"
import script from "./CreateWord.vue?vue&type=script&lang=js"
export * from "./CreateWord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports